import { render, staticRenderFns } from "./ContactDistributions.vue?vue&type=template&id=c99884ee&scoped=true"
import script from "./ContactDistributions.vue?vue&type=script&lang=js"
export * from "./ContactDistributions.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributions.vue?vue&type=style&index=0&id=c99884ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99884ee",
  null
  
)

export default component.exports